import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface OrderResponseItem {
  productId: string;
  productName: string;
  imageUrl: string | null;
  colorName: string;
  colorCode: string;
  size: string;
  quantity: number;
  unitPrice: number;
  lineTotal: number;
}

export interface OrderResponse {
  id: string;
  orderNumber: string;
  createdAt: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  streetAddress: string;
  region: string;
  city: string;
  postalCode: string;
  instructions: string;
  paymentMethod: string;
  status: string;
  subtotal: number;
  total: number;
  items: OrderResponseItem[];
}

export interface OrderListItem {
  id: string;
  orderNumber: string;
  status: string;
  createdAt: string;
  total: number;
  items: { productName: string; quantity: number; imageUrl: string | null }[];
}

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken');
    return new HttpHeaders({ Authorization: `Bearer ${token}` });
  }

  placeGuestOrder(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/orders`, payload);
  }

  placeAuthOrder(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/orders`, payload, {
      headers: this.getAuthHeaders(),
    });
  }

  getUserOrder(id: string): Observable<OrderResponse> {
    return this.http.get<OrderResponse>(`${this.baseUrl}/api/orders/${id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  getMyOrder(): Observable<OrderListItem[]> {
    return this.http.get<OrderListItem[]>(`${this.baseUrl}/api/orders/my`, {
      headers: this.getAuthHeaders(),
    });
  }

  //  Fixed: correct endpoint + correct payload structure
  cancelOrder(id: string, reason: string, note?: string) {
    const body: { reason: string; note?: string } = { reason };

    if (note && note.trim()) {
      body.note = note.trim();
    }

    return this.http.patch(`${this.baseUrl}/api/orders/${id}/cancel`, body, {
      headers: this.getAuthHeaders(),
    });
  }
}
